import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import IndexCard from "../components/indexCard"
import "./index.scss"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="書籍一覧" />
    <section className="indexPage">
      <div className="indexPage-post-list">
        {data.allMicrocmsPost.edges.map(edge => {
          const post = edge.node
          return (
            <IndexCard
              key={post.id}
              id={post.id}
              className="indexPage-post"
              imageUrl={post.image.url}
              title={post.title}
              summary={post.summary}
              createdAt={post.createdAt}
            />
          )
        })}
      </div>
    </section>
  </Layout>
)

export const query = graphql`
  {
    allMicrocmsPost(sort: { fields: createdAt, order: DESC }) {
      edges {
        node {
          title
          summary
          postId
          id
          image {
            url
          }
          createdAt(formatString: "YYYY年MM月DD日")
        }
      }
    }
  }
`

export default IndexPage
